var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E0292",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M8.017.667a5.55 5.55 0 0 0-5.55 5.55v1.75c0 .566-.233 1.416-.525 1.9L.884 11.633c-.65 1.092-.2 2.309 1 2.709a19.45 19.45 0 0 0 12.275 0 1.85 1.85 0 0 0 1-2.709L14.1 9.867c-.291-.484-.525-1.342-.525-1.9v-1.75c-.008-3.05-2.508-5.55-5.558-5.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.121acd0c5755d5a797a94f761924fa5e.svg";
export { ForwardRef as ReactComponent };